<template lang="pug">
#business-management
  v-banner.title-banner(min-height="88")
    .text-h4.font-weight-bold {{ $t('MyBizes.__MyBizes') }}
    template(v-slot:actions)
      v-btn.ml-6(rounded, color="primary", @click="$router.push({ name: 'BusinessNew' })") {{ $t('MyBizes.__AddBiz') }}
  v-container
    Alert
    ConfirmDialog(
      v-model="deleteDialog",
      :title="$t('MyBizes.__DeleteBiz')",
      :message="$t('MyBizes.__ConfirmDeleteBiz')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteBiz"
    )
    v-data-table.mt-2(
      :headers="headers",
      :items="bizes",
      hide-default-footer,
      :options.sync="options",
      :loading="loading",
      :custom-sort="defaultDataSort"
    )
      template(v-slot:item.name="{ item }")
        | {{ item.name }}
      template(v-slot:item.actions="{ item }")
        v-btn.ma-0(text, icon, small, color="primary", @click="editBiz(item)", title="edit")
          v-icon(small) edit
        v-btn.ma-0(
          v-if="ownedBizCheck(item.id)",
          text,
          icon,
          small,
          color="primary",
          @click="deleteDialog = true; deleteId = item.id",
          title="delete"
        )
          v-icon(small) delete
        v-btn.ma-0(v-else, text, icon, small, color="primary", disabled)
          v-icon(small) delete
    v-row.pagination-row
      v-col.d-flex.align-center.justify-start(cols="6")
        //- span.mr-2 每頁顯示項目數：
        //- span
        //-     v-select.page-select(v-model="itemsPerPage" solo dense outlined hide-details :items="perPageItems")
      v-col.d-flex.justify-end(cols="6")
        v-pagination(v-model="options.page", :length="pageCount")
</template>
<script>
import * as datatableHelper from "@/utils/datatableHelper.js"

export default {
  props: ["alert"],
  mixins: [datatableHelper.mixin],

  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,
      deleteDialog: false,
      deleteId: 0,
      headers: [
        {
          text: this.$t("MyBizes.__BizName"),
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: "2SUMUP ID",
          align: "start",
          sortable: true,
          value: "displayId"
        },
        {
          text: "Email",
          align: "start",
          sortable: true,
          value: "email"
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "actions"
        }
      ],
      bizes: []
    }
  },
  watch: {
    options: {
      handler() {
        this.getBizes()
      },
      deep: true
    }
  },
  methods: {
    getBizes() {
      // this.$store.dispatch("global/startLoading")
      var query = this.datatableOptionsToQuery(this.options)
      this.loading = true
      this.$store
        .dispatch("bizes/getBizes", query)
        .then(
          function (response) {
            this.bizes = response.data
            this.pageCount = response.paging.totalPages
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    editBiz(item) {
      var id = item.id
      this.$router.push({
        name: "BusinessEdit",
        params: {
          id: id
        }
      })
    },
    deleteBiz() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bizes/deleteBiz", this.deleteId)
        .then(
          function (response) {
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
            this.getBizes()
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.deleteDialog = false
    },
    ownedBizCheck(bizId) {
      console.log(bizId)
      // console.log(this.bizes.map(biz => biz.id))
      let ownedBizes = this.$store.getters["account/user"]().owned
      console.log(ownedBizes.map(biz => biz.id).includes(bizId))
      return ownedBizes.map(biz => biz.id).includes(bizId)
    }
  },
  mounted() {
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {
    this.getBizes()
  }
}
</script>
